<template>
  <div>
    <!-- <van-sticky> -->
    <van-tabs
      :sticky="true"
      background="#F3F7F7"
      title-active-color="black"
      color="#F3F7F7"
      v-model="active"
    >
      <van-tab title="我的课程">
        <MyCourse :classList="classList" />
      </van-tab>
      <van-tab title="已约直播" style="font-size:0.9rem">
        <MyLive ref="MyLive" @getBookLive="getBookLive" :liveList="liveList" />
      </van-tab>
      <van-tab title="我的资料">
        <MyDataIndex
          ref="MyDataIndex"
          @getDatumList="getDatumList"
          :datumList="datumList"
        />
      </van-tab>
    </van-tabs>
    <!-- </van-sticky> -->
  </div>
</template>

<script>
import MyCourse from "@/components/common/myCourse/myCourse"; // 我的课程
import MyLive from "@/components/common/myLive/myLive"; // 我的课程
// import MyData from '@/components/common/myData/myData'   // 我的资料
import MyDataIndex from "@/components/common/myData/index"; // 我的资料
export default {
  components: {
    MyCourse,
    MyLive,
    MyDataIndex,
  },
  data() {
    return {
      active:0,
      pageIndex: 1,
      classList: [], // 存储课程列表
      live: {
        pageIndex: 1,
      },
      datum: {
        pageIndex: 1,
      },
      liveList: [], // 存储直播列表
      datumList: [], //存储资料拼团列表
    };
  },
  created() {
    // this.getSuccDatePin()  // 获取已拼团的资料
    this.getOrdersCourse(); // 获取我的课程列表
  },
  methods: {
    // 获取我的课程列表
    getOrdersCourse() {
      if(!this.getTokenType()) return false
      this.Api({
        url: "api/mine/getOrdersCourse",
        method: "GET",
      }).then((res) => {
        if (res.message == "success") {
          this.classList = res.data;
        }
      });
    },
    // 获取我的直播列表
    getBookLive() {
      if(!this.getTokenType()) return false

      let that = this;
      this.Api({
        url: `api/mine/getBookLive?pageIndex=${that.live.pageIndex}`,
        method: "GET",
      }).then((res) => {
        res.data.data.forEach((item) => {
          that.liveList.push(item);
        });
        that.live.pageIndex += 1;
        this.$refs.MyLive.loading = false;
        if (that.liveList.length + 1 >= res.data.total) {
          that.$refs.MyLive.finished = true;
        }
      });
    },
    getDatumList() {
      if(!this.getTokenType()) return false

      let that = this;
      this.Api({
        url: `api/mine/getDatumPinList?pageIndex=${that.datum.pageIndex}`,
        methods: "GET",
      }).then((res) => {
        res.data.data.forEach((item) => {
          that.datumList.push(item);
        });
        that.datum.pageIndex += 1;
        this.$refs.MyDataIndex.loading = false;
        if (that.datumList.length + 1 >= res.data.total) {
          that.$refs.MyDataIndex.finished = true;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-tab--active {
  font-size: 0.9rem;
  font-weight: 800;
}
</style>
